// lib/format.js and lib/whatsapp.js are plain synchronous functions
// called from deep inside render trees — they can't be hooks. This is a
// small synced mirror of the real settings query (see features/settings/api.js),
// kept fresh via that hook's onSuccess, so those plain functions can read
// a value synchronously without every call site becoming async.
export const settingsCache = {
  currencySymbol: "$",
  whatsappNumber: "",
};

export function setSettingsCache(data) {
  Object.assign(settingsCache, data);
}
